function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKintoEmblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 1400 900",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 336 235.2"
    },
    width: "1400px",
    height: "900px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.541252613067627, 0, 0, 2.541252613067627, -0.000009262253115593921, 0.21245574951171875)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 1400,
    height: 900,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.1959617137908936, 0, 0, 2.1959617137908936, 222.4476318359375, 152.39712524414062)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.5,9.3c-1.4-1.1-3.5-1.3-5.4,0c-2.6,1.8-2.9,5-1.5,7.5c1.4,2.5,4,3.4,7,3.1c3.4-0.3,6.1-2.2,7.7-4.3 c1.4-1.9,3-6.6-0.1-11.1C71.9,1.1,68.9,0,65.7,0c-3.6,0-6,2.7-7.7,4.7c-2.6,3.1-3.8,3.8-6.1,4c-2.3,0.2-4.4-0.8-5.4-1.8 c-1-1.1-1.6-1.9-1.6-1.9s1.3,2.4,3,3.8c1.8,1.5,4.6,2.3,7.7,1.2c3.6-1.3,5.5-3.5,6.7-4.2c2.4-1.4,5.8-0.3,6.5,2.2 c0.8,2.9-0.8,4.9-0.8,4.9S68.5,10.8,66.5,9.3",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(8.062797460703186, 0, 0, 8.062797460703186, -463.18293286820824, -69.18958849086647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 98.77657318115234 14.051992416381836",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeWidth: 0,
      paintOrder: "fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 88.52691650390625 13.197854042053223",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeWidth: 0,
      paintOrder: "fill"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKintoEmblem);
export default __webpack_public_path__ + "static/media/kinto_emblem.737a2e92eac242041d36212bf7992ca4.svg";
export { ForwardRef as ReactComponent };